<template>
  <el-dialog v-model="visible" :style="{ '--el-dialog-padding-primary': 0 }" append-to-body :show-close="false" width="564px" :close-on-click-modal="false">
    <div class="data-init">
      <div class="data-init-title">
        <span>初始化</span>
        <i class="iconfont icon-shanchu3" @click="close"></i>
      </div>
      <div class="data-init-body">
        <div v-html="text"></div>
      </div>
      <div class="data-init-foot">
        <el-button type="primary" @click="confirm">确认</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { dealText } from '@/api/common';
import { getDataSyncConfig } from '../component/mutual/common/config';
import { datasyncform } from '@/port/schoolInstrument/appConfig.js'

export default {
  // 组件名称
  name: 'dataSyncInit',
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      visible: false,
      text: '',
      dataSyncConfig: {},
      appInfo: {},
      query: {}
    }
  },
  // 计算属性
  computed: {},
  // 组件方法
  methods: {
    open(config = {}) {
      const { dataSyncConfig, count, appInfo, query } = config
      const text = dealText({ text: dataSyncConfig.reconfirmConfig, asyncCount: count })
      this.text = text
      this.dataSyncConfig = dataSyncConfig
      this.appInfo = appInfo
      this.query = query
      this.upperLimit = count > dataSyncConfig.maxSyncNum
      this.visible = true
    },
    async confirm() {
      const param = getDataSyncConfig(this.dataSyncConfig, this.appInfo)
      const res = await datasyncform({ syncConfig: param, syncstatus: 1, query: this.query })
      if (res.code === 0) {
        const info = {
          addnum: res.addnum,
          updatenum: res.updatenum,
          errornum: res.failnum,
          failpath: res.failpath,
        }
        this.$emit('confirm', { info, dataSyncConfig: this.dataSyncConfig })
      }
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  },
}
</script>

<style scoped lang="scss">
.data-init {
  height: 223px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  &-title {
    height: 35px;
    border-bottom: solid 1px #e6e6e6;
    display: flex;
    justify-content: space-between;

    span {
      color: #000000;
      font-weight: 400;
      font-size: 16px;
    }

    .icon-shanchu3 {
      font-size: 14px;
      color: #D8D7D7;
      cursor: pointer;

      &:hover {
        color: #4e86ff;
      }
    }
  }

  &-body {
    flex: 1;

    .body-title {
      margin-top: 20px;
      color: #000000;
      font-weight: 400;
      font-size: 16px;

      span {
        color: #D0021B;
        margin: 0 5px;
      }
    }

    .body-tips {
      font-family: uniqueID;
      color: #808182;
      font-weight: 400;
      font-size: 14px;
      margin-top: 24px;
    }
  }

  &-foot {
    height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
